var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg p-0 ml-4",staticStyle:{"background":"none"}},[_c('feedbackStat'),_c('improvementStat'),_c('productivityStat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }